import Notification, { NotificationProps } from './Notification';

export type { NotificationProps };
export default Notification;
